module.exports = [{"name":"English","locale":"en","country":"us","fallback":true},{"name":"Español","locale":"es","country":"es"},{"name":"Português","locale":"pt-BR","country":"br"},{"name":"Italiano","locale":"it","country":"it"},{"name":"Francês","locale":"fr","country":"fr"},{"name":"Alemão","locale":"de","country":"de"},{"name":"Russo","locale":"ru","country":"ru"}]


//////////////////
// WEBPACK FOOTER
// ./src/i18n/languages.json
// module id = zxkL
// module chunks = 1